import './styles.scss';

const VideoModal = (props) => {
  const { id, video_raw, toggleVideoModal, property_video } = props;
  return (
    <div className="modal-container">
        <div className="modal-bg">
          <img onClick={()=>{ toggleVideoModal(null, '', '')}} className="modal-container-close"
               src="/wp-content/themes/hayden/assets/images/icons/white-x-lrg.svg" alt="close form"/>
          <div className="modal-content">
            <div className="embed-responsive embed-responsive-16by9" dangerouslySetInnerHTML={{__html: property_video }} />
          </div>
      </div>
    </div>
  )
}


export default VideoModal;
